// Kid area = these paths while a student is signed in.
const KID_PATHS = [/^\/home$/, /^\/homework$/, /^\/stars$/, /^\/activit/, /^\/lessons?(\/|$)/, /^\/adventures/, /^\/courses\//, /^\/projects/, /^\/community/, /^\/assignment\//, /^\/games?(\/|$)/,
  /^\/pixel-trial/, /^\/code-trial/, /^\/python-trial/, /^\/design-thinking/, /^\/mind-map/, /^\/whiteboard/, /^\/paint/, /^\/canvas/];
export const isKidPath = (p) => KID_PATHS.some((r) => r.test(p));
